





























import { Vue, Component, Prop } from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { imgFileTypes } from '@/common/accepted-file-types';

@Component({
  name: 'BaseImageUpload',
  inheritAttrs: false,
  components: {
    Icon,
  },
})
export default class BaseImageUpload extends Vue {
  @Prop({ default: imgFileTypes.toString() }) acceptedFileTypes: string;
  @Prop() imgUrl?: string;
  @Prop({ default: 130 }) width: number;
  @Prop({ default: 130 }) height: number;

  fileDataUrl = '';
  file: File = undefined;
  showDefault = false;

  get thumbUrl(): string {
    if (this.showDefault) {
      return '';
    }
    return this.fileDataUrl || this.imgUrl || '';
  }

  get tooltip() {
    return {
      content: this.$t('click-to-upload'),
      delay: { show: 0, hide: 100 },
      container: '.image-upload',
      placement: 'bottom',
    };
  }

  handleDelete() {
    this.showDefault = true;
    this.$emit('delete');
  }

  handleSelectFile(event: Event) {
    const { files } = event.target as HTMLInputElement;

    if (!files?.length) {
      return;
    }

    this.file = files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.fileDataUrl = reader.result as string;
    };
    reader.readAsDataURL(files[0]);

    this.$emit('upload', this.file);
  }
}
